import { graphql } from "gatsby";
import React, { useEffect } from "react";
import { connect } from "react-redux";
import { useI18next } from "gatsby-plugin-react-i18next";

import Layout from "../../components/Layout";
import AccountLogin from "../../components/AccountLogin";
import LayoutFloating from "../../components/LayoutFloating";
import { regionRequest } from "../../actions";

const Login = (props) => {
  const {
    region_data: { unique_region_text, active_language },
    region_loading,
    dispatch,
  } = props;
  const { language } = useI18next();

  useEffect(() => {
    if (
      (!region_loading && !unique_region_text) ||
      language !== active_language
    ) {
      dispatch(regionRequest(language));
    }
  }, [unique_region_text, region_loading, language, dispatch, active_language]);

  return (
    <Layout
      pageName="account-login"
      showHeader={false}
      siteTitle={unique_region_text?.siteTitle ?? ""}
      siteDescription={unique_region_text?.siteDescription ?? ""}
    >
      <LayoutFloating title={unique_region_text?.siteTitle ?? ""}>
        <AccountLogin {...props} />
      </LayoutFloating>
    </Layout>
  );
};

export default connect((state) => state)(Login);

export const query = graphql`
  query ($language: String!) {
    locales: allLocale(filter: { language: { eq: $language } }) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
  }
`;
